import { CONTACTS } from '@shared/contants'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface TopMenuContactsProps {
  className?: string;
}

export default function TopMenuContacts ({ className }: TopMenuContactsProps) {
  return (
    <div className={cn(styles.topMenuContacts, className)}>
      {CONTACTS.phone && (
        <a
          href={`tel:${CONTACTS.phone}`}
          className={styles.topMenuContacts__phone}
        >
          {CONTACTS.phone}
        </a>
      )}
    </div>
  )
}
